PointPathLayer = require './point-path-layer'

module.exports = App.CircleLayerComponent = PointPathLayer.extend
  leafletRequiredOptions: [ 'radius' ]
  leafletProperties: [ 'radius' ]
  createLayer: ->
    @L.circle.apply @L, @get('requiredOptions').concat([ @get('options') ])